import { render, staticRenderFns } from "./GuidanceAssistant.vue?vue&type=template&id=0df2cdff&scoped=true"
import script from "./GuidanceAssistant.vue?vue&type=script&lang=js"
export * from "./GuidanceAssistant.vue?vue&type=script&lang=js"
import style0 from "./GuidanceAssistant.vue?vue&type=style&index=0&id=0df2cdff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df2cdff",
  null
  
)

export default component.exports